import { render } from "./LawyerDetail.vue?vue&type=template&id=4a5aa622&scoped=true"
import script from "./LawyerDetail.vue?vue&type=script&lang=js"
export * from "./LawyerDetail.vue?vue&type=script&lang=js"

import "./LawyerDetail.vue?vue&type=style&index=0&id=4a5aa622&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a5aa622"]])

export default __exports__